export default {
    formatWcInfo: (vertigisResult) => {
        const elements = [];

        elements.push(vertigisResult?.BARRIER ? 'barrierefrei' : 'nicht barrierefrei')

        if (vertigisResult?.KOSTEN) {
            elements.push('kostenpflichtig')
        }

        if (vertigisResult?.OFFEN) {
            elements.push(vertigisResult?.OFFEN)
        }

        return elements.join(', ')
    },
    formatWcAddress: (vertigisResult) => {
        const elements = [];
        const elementsDistrict = [];

        if (vertigisResult?.LAGE) {
            elements.push(vertigisResult?.LAGE)
        }

        if (vertigisResult?.PLZ_ORT) {
            elementsDistrict.push(vertigisResult?.PLZ_ORT)
        }

        if (vertigisResult?.STADTTEIL) {
            elementsDistrict.push(vertigisResult?.STADTTEIL)
        }

        if (elementsDistrict.length > 0) {
            elements.push(elementsDistrict.join(' '))
        }

        return elements.join(', ')
    }
}
